export default __webpack_public_path__ + "static/media/filings-icon.0c577066.png";